import router from "@/router";
import VueScrollTo from "vue-scrollto";

export const goToErrorPage = (e) => {
  // console.error('Error!!!!!', e)
  if (
    window.__PRERENDER_INJECTED &&
    window.__PRERENDER_INJECTED.isPrerendering
  ) {
    return;
  }
  if (e && e.toString().indexOf("api_status") !== -1) {
    return;
  }
  router.push({ name: "InternalServerError" });
};

export const scrollTop = () => {
  VueScrollTo.scrollTo(document.getElementsByTagName("body"), 300, {
    easing: "ease",
  });
};
